export default "__VITE_ASSET__DptEUtoW__"